import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TableColumn } from '@flyfreely-portal-ui/flyfreely-table';
import { IFloatingFilterAngularComp } from 'ag-grid-angular';
import { IFloatingFilterParams } from 'ag-grid-community';

/** What the floating filter needs from the hosting table component */
export interface FloatingFilterHost {
    filterForm: FormGroup;
    compareSearchOption: (a: any, b: any) => boolean;
}

export interface FlightLogFloatingFilterParams extends IFloatingFilterParams {
    tableColumn: TableColumn;
    context: FloatingFilterHost;
}

/**
 * The typed per-column search control (text / daterange / selection) rendered
 * in AG Grid's floating filter row, bound to the host table's FormGroup.
 * The grid's own filter model is intentionally unused: filtering is external.
 */
@Component({
    selector: 'flight-log-floating-filter',
    template: `
        <ng-container *ngIf="control != null">
            <input
                *ngIf="col.searchable === 'text'"
                type="text"
                class="form-control input-sm"
                [formControl]="control"
                [placeholder]="col.searchPlaceholder ?? 'Search'"
            />
            <input
                *ngIf="col.searchable === 'daterange'"
                type="text"
                class="form-control input-sm"
                [formControl]="control"
                [placeholder]="col.searchPlaceholder ?? 'Select range'"
                bsDaterangepicker
                container="body"
                triggers="click"
            />
            <ng-select
                *ngIf="col.searchable === 'selection'"
                class="floating-filter-select"
                [formControl]="control"
                [items]="col.searchOptions"
                bindLabel="name"
                bindValue="value"
                [groupBy]="col.groupBy"
                [compareWith]="host.compareSearchOption"
                [placeholder]="col.searchPlaceholder ?? 'All'"
                [clearable]="col.clearableSearch !== false"
                appendTo="body"
            ></ng-select>
        </ng-container>
    `,
    styles: [
        `
            :host {
                display: block;
                width: 100%;
            }
            .form-control.input-sm {
                height: 26px;
                padding: 2px 8px;
                font-weight: normal;
            }
            ::ng-deep .floating-filter-select .ng-select-container {
                min-height: 26px;
                height: 26px;
                font-weight: normal;
            }
        `
    ]
})
export class FlightLogFloatingFilter implements IFloatingFilterAngularComp {
    col: TableColumn;
    host: FloatingFilterHost;
    control: FormControl;

    agInit(params: FlightLogFloatingFilterParams) {
        this.col = params.tableColumn;
        this.host = params.context;
        this.control = this.host.filterForm.get(this.col.key) as FormControl;
    }

    onParentModelChanged() {
        // Filtering is external; the grid's filter model is not used
    }
}
